import React from 'react';

interface StatCardProps {
  value: string | number;
  label: string;
  variant?: 'card' | 'row';
  className?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  value,
  label,
  variant = 'card',
  className = '',
}) => {
  if (variant === 'row') {
    return (
      <div className={`flex justify-between text-sm ${className}`}>
        <span className="text-gray-600 dark:text-gray-400">{label}:</span>
        <span className="text-gray-900 dark:text-gray-100">{value}</span>
      </div>
    );
  }

  return (
    <div
      className={`text-center p-4 bg-gray-50 dark:bg-gray-800 rounded-lg ${className}`}
    >
      <div className="text-2xl font-bold text-gray-900 dark:text-gray-100">
        {value}
      </div>
      <div className="text-sm text-gray-500 dark:text-gray-400">{label}</div>
    </div>
  );
};

export default StatCard;
